(function($) {
$(document).ready(function() {

var params = {};
params.sep = ' ';
params.error = 'Message cannot be decoded';
params.noInv = 'Please use another matrix';
params.save = true;

$$.body = $('body');
$$.encode = $('#encode');
$$.decode = $('#decode');
$$.encoded = $('#encoded');
$$.decoded = $('#decoded');
$$.mKey = $('#mKey');
$$.tKey = $$.mKey.find('tbody');
$$.rKey = $$.mKey.find('input.rows');
$$.cKey = $$.mKey.find('input.cols');
$$.save = $('#save');

// Repeat a string a number of times
function repeat(str, n) {
	var i, repeated = str;
	str = '';
	for (i=0; i<n; i+=1) {
		str += repeated;
	}
	return str;
}

// Encode message
function encode(decoded) {

	var encoded = [],
		groups = [],
		mPair,
		m1 = toArray('mKey'),
		mInv = Calc.matrix(m1).inv(),
		nrows = m1.length,
		c, g;

	// Matrix must have an inverse
	if (mInv === null) {
		$$.encoded.addClass('null');
		return params.noInv;
	} else {
		$$.encoded.removeClass('null');
	}

	// Truncate spaces
	decoded = decoded.replace(/\s+/gi, ' ');
	// Remove whitespace at beginning and end
	decoded = decoded.replace(/(^\s+)|(\s+$)/gi, '');
	// If message has an odd number of characters

	if (decoded.length % nrows !== 0) {
		decoded += repeat(' ', nrows - (decoded.length % nrows));
	}
	$$.decoded
		.val(decoded)
		.removeClass('null');

	// Loop through string, creating groups of n characters from the string
	for (c=0; c<decoded.length; c+=1) {

		// Create new group when one group has a length of n
		if (c % nrows === 0) {
			groups.push([]);
		}
		groups[groups.length - 1].push(decoded[c].charCodeAt(0));

	}
	// Encode groups of letters
	for (g=0; g<groups.length; g+=1) {
		encoded.push(
			Calc.matrix([groups[g]])
				.multiply(m1)
				.matrix[0]
				.join(params.sep)
			);
	}

	return encoded.join(params.sep);
}

// Decode message
function decode(encoded) {
	var mInv = Calc.matrix(toArray('mKey')).inv(),
		decoded = [],
		groups = [],
		product, nrows, i;

	// Matrix must have an inverse
	if (mInv === null) {
		$$.decoded.addClass('null');
		return params.noInv;
	} else {
		$$.decoded.removeClass('null')
		mInv = mInv.matrix;
		nrows = mInv.length;
	}

	encoded = encoded.split(params.sep);

	// Loop through string, creating groups of n numbers from the string
	for (c=0; c<encoded.length; c+=1) {

		// Create new group when one group has a length of n
		if (c % nrows === 0) {
			groups.push([]);
		}
		groups[groups.length - 1].push(encoded[c]);

	}

	// Decode groups of numbers
	for (g=0; g<groups.length; g+=1) {
		letters = product = Calc.matrix([groups[g]]).multiply(mInv);
		if (letters) {
			product = letters.matrix[0];
			for (c=0; c<product.length; c+=1) {
				decoded += String.fromCharCode(Math.round(product[c]));
			}
		}
	}

	return decoded;
}

// Load data from storage
function load() {
	if (!window.localStorage) {return;}
	var loaded = localStorage.getItem('matrix-encoder');
	// If information already has been saved
	if (loaded !== null) {
		loaded = JSON.parse(loaded);
		params.save = loaded.save;
		$$.save[0].checked = params.save;
		// Only save encoder info if chosen
		if (params.save) {
			$$.encoded.val(loaded.encoded);
			$$.decoded.val(loaded.decoded);
			if (loaded.isNull) {
				$$.decoded.addClass('null');
			}
			toTable({
				id: 'mKey',
				matrix: loaded.key
			});
		}
	}
}

// Save data to storage
function save() {
	if (window.localStorage) {
		var data = {};
		data.save = params.save;
		// Only save encoder info if chosen
		if (data.save) {
			data.encoded = $$.encoded.val();
			data.decoded = $$.decoded.val();
			data.isNull = $$.decoded.hasClass('null');
			data.key = toArray('mKey');
		}
		localStorage.setItem('matrix-encoder', JSON.stringify(data));
	}
}

// "Encode" button
$$.encode.on('click', function() {
	var decoded = $$.decoded.val();
	if (decoded === '') {return;}
	$$.encoded.val(encode(decoded));
	save();
});
// "Decode" button
$$.decode.on('click', function() {
	var encoded = $$.encoded.val();
	if (encoded === '') {return;}
	$$.decoded.val(decode(encoded));
	save();
});

// Save inputs when changed
$$.body.on('change', 'input', function() {
	save();
});
$$.decoded.on('click', function() {
	var $this = $(this);
	if ($this.hasClass('null')) {
		$this.select();
	}
});

// "Save" checkbox
$$.save.on('change', function() {
	params.save = this.checked;
	save();
});

load();
// Encode message automatically
if ($$.encode.hasClass('.null')) {
	$$.encode.trigger('click');
}
save();

});
}(jQuery));
